import { render, staticRenderFns } from "./ViewAutoAvaliacao.vue?vue&type=template&id=bb679780&scoped=true"
import script from "./ViewAutoAvaliacao.vue?vue&type=script&lang=js"
export * from "./ViewAutoAvaliacao.vue?vue&type=script&lang=js"
import style0 from "./ViewAutoAvaliacao.vue?vue&type=style&index=0&id=bb679780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb679780",
  null
  
)

export default component.exports